import { atom, getDefaultStore } from "jotai";
import { useMemo } from "react";

const goalsBoardAttachedAtom = atom<Record<number, boolean>>({});

export const makeGoalsBoardAttachedAtom = (otherUserId: number) =>
    useMemo(
        () =>
            atom(
                (get) => get(goalsBoardAttachedAtom)[otherUserId] ?? false,
                (get, set, value: boolean) => {
                    set(goalsBoardAttachedAtom, {
                        ...get(goalsBoardAttachedAtom),
                        [otherUserId]: value,
                    });
                },
            ),
        [otherUserId],
    );

export const setGoalsBoardAttachedAtom = atom(
    null,
    (
        get,
        set,
        { otherUserId, value }: { otherUserId: number; value: boolean },
    ) => {
        set(goalsBoardAttachedAtom, {
            ...get(goalsBoardAttachedAtom),
            [otherUserId]: value,
        });
    },
);

export const isShowingAttachmentsAtom = atom<boolean>(false);
isShowingAttachmentsAtom.onMount = (set) => () => set(false);

export const chatJumpToMessageAtom = atom<
    ((messageExternalId: string) => void) | null
>(null);

export const isFastReplyModeAtom = atom<boolean>(false);
isFastReplyModeAtom.onMount = () => () => {
    if (!route().current("chat")) {
        getDefaultStore().set(isFastReplyModeAtom, false);
    }
};
